"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ValidationErrors_1 = require("../../enums/Validation/ValidationErrors");
const Resource_1 = __importDefault(require("../Resource"));
const Custom_1 = __importDefault(require("../decorators/Custom"));
const EGenter_1 = require("../../enums/Gender/EGenter");
class UserCompleteProfileRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.gender = EGenter_1.EGender.autre;
    }
}
exports.default = UserCompleteProfileRequestResource;
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.trim()),
    (0, class_validator_1.IsStrongPassword)({
        minLength: 8,
        minLowercase: 0,
        minUppercase: 0,
        minNumbers: 0,
        minSymbols: 0,
    }),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "password", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.trim()),
    (0, Custom_1.default)((confirmPassword, args) => confirmPassword === args.object.password, {
        message: ValidationErrors_1.EValidationError.passwordNotMatch,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "confirmPassword", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.trim()),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MinLength)(3),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.trim()),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MinLength)(3),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.toLowerCase().trim()),
    (0, class_transformer_1.Transform)(({ value }) => value?.replace(/ /gim, "")),
    (0, class_validator_1.IsNotEmpty)(),
    (0, Custom_1.default)((value) => {
        if (value.startsWith("+"))
            return (0, class_validator_1.isMobilePhone)(value);
        return (0, class_validator_1.isMobilePhone)(value, "fr-FR");
    }, { message: ValidationErrors_1.EValidationError.invalidPhoneNumber }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "phoneNumber", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.toLowerCase().trim()),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "address", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.toLowerCase().trim()),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNumberString)({ no_symbols: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "zipCode", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => value?.toLowerCase().trim()),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(EGenter_1.EGender),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserCompleteProfileRequestResource.prototype, "gender", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, Custom_1.default)((value) => new Date(value) < new Date(), { message: ValidationErrors_1.EValidationError.mustBeInThePast }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], UserCompleteProfileRequestResource.prototype, "birthDate", void 0);
